<template lang="pug">
Dropdown.with-hover(v-if="import_dropdown_options" :options="import_dropdown_options" :disabled="disable_import")
  template(v-slot:button="scope")
    Button(
      type="dropdown"
      label="Import"
      :active="scope.opened"
      :flip="true"
      :tooltip="{value: 'Import to make new creative'}"
    )
      template(v-slot:suffix)
        IconDropdown
</template>

<script>
import CreativesMixins from '@cm/Views/Creatives/Components/CreativesMixins';

import Button from '@master/UI/Buttons/Button';
import Dropdown from '@master/UI/Dropdown';
import IconDropdown from '@master/UI/Buttons/Icons/IconDropdown';

import { IMPORT } from '@master/constants';

export default {
  name: 'CreativesImport',
  mixins: [CreativesMixins],

  components: {
    Button,
    Dropdown,
    IconDropdown,
  },

  props: {
    disable_import: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    show_HTML5_option() {
      if (this.admin_toggle) return true;
      return !this.instream_expert;
    },

    show_social_option() {
      return this.$user.isSocialApproved() || this.$user.isNexdAdmin();
    },

    import_dropdown_options() {
      let options = [];

      options.push({
        icon: 'nexd-icon-32-video',
        label: 'Import VAST',
        onclick: () => this.$emit('createPlacement', IMPORT.VAST),
      });

      if (this.show_HTML5_option) {
        let text = 'Import HTML5';
        if (this.show_HTML5_option && this.admin_toggle)
          text = 'Import HTML5 Zip/Tag';

        options.push({
          icon: 'nexd-icon-32-html5',
          label: text,
          onclick: () => this.$emit('createPlacement', IMPORT.HTML5),
        });
      }

      options.push({
        icon: 'nexd-icon-32-xls-csv-file',
        label: 'Import data from XLS / CSV',
        onclick: () => this.$emit('createPlacement', IMPORT.EXCEL),
      });

      if (this.show_social_option) {
        options.push({
          icon: 'nexd-icon-32-facebook',
          label: 'Import from Social',
          onclick: () => this.$emit('createPlacement', IMPORT.SOCIAL),
        });
      }

      if (this.show_responsive_type_option) {
        options.splice(1, 0, {
          label: 'Import Responsive',
          tooltip: { template: 'cm.responsive', position: 'left' },
          onclick: () => this.$emit('createPlacement', IMPORT.QUANTUM),
          icon: 'nexd-icon-32-responsive',
        });
      }

      return options;
    },
  },
};
</script>
